module.exports = __webpack_public_path__ + "static/media/logo-animation.c42e7194.mp4";